"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TDocDeployer__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [{
    internalType: "address",
    name: "target",
    type: "address"
  }],
  name: "AddressEmptyCode",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "ERC1967InvalidImplementation",
  type: "error"
}, {
  inputs: [],
  name: "ERC1967NonPayable",
  type: "error"
}, {
  inputs: [],
  name: "FailedCall",
  type: "error"
}, {
  inputs: [],
  name: "FailedDeployment",
  type: "error"
}, {
  inputs: [],
  name: "ImplementationAlreadyAdded",
  type: "error"
}, {
  inputs: [{
    internalType: "bytes",
    name: "payload",
    type: "bytes"
  }],
  name: "ImplementationInitializationFailure",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "balance",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "needed",
    type: "uint256"
  }],
  name: "InsufficientBalance",
  type: "error"
}, {
  inputs: [],
  name: "InvalidImplementation",
  type: "error"
}, {
  inputs: [],
  name: "InvalidInitialization",
  type: "error"
}, {
  inputs: [],
  name: "NotInitializing",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "OwnableInvalidOwner",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "OwnableUnauthorizedAccount",
  type: "error"
}, {
  inputs: [],
  name: "UUPSUnauthorizedCallContext",
  type: "error"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "slot",
    type: "bytes32"
  }],
  name: "UUPSUnsupportedProxiableUUID",
  type: "error"
}, {
  inputs: [],
  name: "UnsupportedImplementationContractAddress",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }],
  name: "AddImplementation",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "deployed",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "deployer",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "params",
    type: "bytes"
  }],
  name: "Deployment",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint64",
    name: "version",
    type: "uint64"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "Upgraded",
  type: "event"
}, {
  inputs: [],
  name: "UPGRADE_INTERFACE_VERSION",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }, {
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }],
  name: "addImplementation",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }, {
    internalType: "bytes",
    name: "params",
    type: "bytes"
  }],
  name: "deploy",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "implementations",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "proxiableUUID",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "removeImplementation",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newImplementation",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "upgradeToAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class TDocDeployer__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.TDocDeployer__factory = TDocDeployer__factory;
_defineProperty(TDocDeployer__factory, "bytecode", _bytecode);
_defineProperty(TDocDeployer__factory, "abi", _abi);